/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import CloseButton from '../../../components/buttons/CloseButton';

class CashBoxPopup extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        allOrganizationCashboxes: React.PropTypes.object,
        onSubmit: React.PropTypes.func.isRequired,
        onClose: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.scrollBy = this.scrollBy.bind(this);
    }

    scrollBy(down) {
        const div = document.getElementById("popupScroll");
        if (down) {
            div.scrollTop += 100;
        } else {
            div.scrollTop -= 100;
        }
    }

    render() {
        const {allOrganizationCashboxes, onSubmit, onClose, msg} = this.props;

        return (
            <div className="popup">
                <div className="popup-block">
                    <div className="popup-content" id="popupScroll">
                        <div className="popup-inner">
                            <h1 className="popup-title">{msg.transactions.chooseCashbox}</h1>
                            <div className="popup-list">
                                {!!allOrganizationCashboxes && allOrganizationCashboxes.map(c =>
                                  <div className="popup-list-key" key={`cashbox-${c.get('id')}`}>
                                    <div className="boxBtn color-white"
                                         onClick={() => onSubmit(c.get('id'))}>
                                        <div className="boxBtn-inner">
                                            <span>
                                                {c.get('name')}
                                            </span>
                                        </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="popup-controls">
                      <div className="popup-controls-key">
                        <div className="boxBtn color-white">
                            <div className="boxBtn-inner" onClick={() => this.scrollBy(false)}>
                                <i className="ico-up"/>
                            </div>
                        </div>
                      </div>
                      <div className="popup-controls-key">
                        <div className="boxBtn color-white" onClick={() => onClose()}>
                            <CloseButton/>
                        </div>
                      </div>
                      <div className="popup-controls-key">
                        <div className="boxBtn color-white">
                            <div className="boxBtn-inner" onClick={() => this.scrollBy(true)}>
                                <i className="ico-down"/>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    allOrganizationCashboxes: state.cashboxes.get('allOrganizationCashboxes')
}), {})(CashBoxPopup);



// WEBPACK FOOTER //
// ./src/browser/menu/report/transactions/CashBoxPopup.js